export const downTimeData  = [
    {
        label: 'CHP1',
        sliceList: [
            {
                assetId: '7f9ecd5f-c75e-4b08-8b5c-b7a2fdec5bbd',
                backgroundColor: '#DAA520',
                boFitStatus: 'REQUESTED',
                borderColor: '#8B8000',
                createdTS: '2024-08-15T11:54:37.002445Z',
                fixedValue: null,
                from: new Date('2024-01-01T07:00:00Z').toString(),
                id: '58a98f37-f7c2-4e2f-b767-0cc248afe380',
                label: 'LIMITED',
                maxValue: 1200,
                minValue: 900,
                stripeColor: '#BDB76B',
                subLabel: 'Min. 900.0 kW - Max. 1200.0 kW limited',
                tagList: [],
                tenantId: 'WESTFALENLAND',
                to: new Date().toString(),
                type: 'normal',
                unit: 'kW',
            },
            {
                id: '7b783621-382b-42fb-8228-8a2cafb09e21',
                backgroundColor: '#2E8B57',
                boFitStatus: 'REQUESTED',
                borderColor: '#006400',
                createdTS: '2024-08-05T11:52:56.099669Z',
                fixedValue: null,
                from: new Date().toString(),
                label: 'AVAILABLE',
                maxValue: null,
                minValue: null,
                stripeColor: '#228B22',
                subLabel: 'available',
                tagList: [],
                tenantId: 'WESTFALENLAND',
                to: new Date('2024-12-25T22:00:00Z').toString(),
                type: 'normal',
                unit: 'kW',
            },
        ],
    },
    {
        label: 'CHP2',
        sliceList: [
            {

                assetId: '945e23ca-8d91-4d9d-b6db-8b886ffdc0b3',
                backgroundColor: '#1E90FF',
                boFitStatus: 'REQUESTED',
                borderColor: '#00008B',
                createdTS: '2024-08-05T11:54:16.587023Z',
                fixedValue: null,
                from: '2024-08-05T06:00:00Z',
                id: 'c6af708a-4351-4853-932f-3fb206d1324d',
                label: 'UNUTILIZED',
                maxValue: null,
                minValue: null,
                stripeColor: '#0000CD',
                subLabel: 'unutilized',
                tagList: [],
                tenantId: 'WESTFALENLAND',
                to: '2024-08-30T20:00:00Z',
                type: 'normal',
                unit: 'kW',
            },
        ],
    },
];
